import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const Spinner = ({ path = "login" }) => {
  const [count, setCount] = useState(3);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const interval = setInterval(() => {
      setCount((prevValue) => prevValue - 1);
    }, 1000);

    if (count === 0) {
      navigate(`/${path}`, { state: location.pathname });
    }

    return () => clearInterval(interval);
  }, [count, navigate, location, path]);

  return (
    <div
      className="d-flex flex-column justify-content-center align-items-center"
      style={{
        height: "100vh",
        backgroundColor: "#000",
        color: "#fff",
      }}
    >
      <h1 className="text-center mb-4">
        Redirecting you in {count} second(s)...
      </h1>
      <div
        className="spinner-border"
        role="status"
        style={{
          width: "3rem",
          height: "3rem",
          borderWidth: "0.4rem",
          color: "#e83e8c",
          borderColor: "#e83e8c transparent #e83e8c transparent",
        }}
      >
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  );
};

// Default export to fix the "not found" issue
export default Spinner;
